import { Key } from 'react';
import { Cell, Checkbox } from '@bst/react-ui';
import { RenderCellProps } from '@bst/react-data-grid';

import { InvitationStrategy, UserDTO } from '../../../apiclients/bstinsights';
import { Avatar } from '../../Avatar/View/Avatar';

type Props = {
  selected: Key[];
  invitationStrategy: InvitationStrategy
  isUserInvitable: (user: UserDTO) => boolean;
  handleSelectRows: (keys: Key[]) => void
} & RenderCellProps<UserDTO, unknown>;

export const UserNameCell = ({
  selected,
  invitationStrategy,
  isUserInvitable,
  handleSelectRows,
  ...props
}: Props) => {
  const [firstName, lastName] =
    props.row?.displayName?.split(" ") ?? [];
  const abbr =
    firstName && lastName
      ? `${firstName?.charAt(0)}${lastName?.charAt(0)}`
      : "";
  const displayName = props.row.displayName!;
  const userId = props.row.userId!;

  const checked =
    invitationStrategy === 0
      ? selected.includes(userId)
      : !selected.includes(userId);


  const handleCheckedChange = () => handleSelectRows([userId])

  return (
    <Cell
      className="user-management-avatar-checkbox-cell"
      data-checkbox={selected.length > 0}
    >
      <div>
        {!checked && (
          <Avatar className="user-management-avatar" abbr={abbr} />
        )}
        {isUserInvitable(props.row) && (
          <Checkbox
            data-testid={`select-user-${props.row.userId}`}
            className="user-management-checkbox"
            checked={checked}
            onCheckedChange={handleCheckedChange}
          />
        )}
      </div>
      <span data-testid="displayName">{displayName}</span>
    </Cell>
  );
}